<template>
    <div class="footer">

        <div class="bg-footer">
            <b-container fluid="lg" class="py-4">

                <b-row class="menu">
                    <b-col sm="12" md="3" lg="3" xl="3">
                        <p class="font-italic">Στροφή στην επιτυχία!</p>

                        <p class="text-uppercase font-weight-bold mb-4">Σχετικά με εμάς</p>
                        <ul class="list-unstyled mb-0">
                            <li class="mb-2"><a :href="$store.getters.global.urls.view.about_us">{{ __('global.link.about_us') }}</a></li>
                            <li class="mb-2"><router-link :to="{name : 'news'}">{{ __('page/page.news.title') }}</router-link></li>
                            <li class="mb-2"><router-link :to="{ name:'contact' }">{{ __('global.link.contact') }}</router-link></li>
                            <li class="mb-2"><router-link :to="{ name:'donate' }">Κάντε μια δωρεά και κάντε τη διαφορά</router-link></li>
                        </ul>

                        <ul class="list-inline mt-4">
                            <li class="list-inline-item mr-4"><a rel="noreferrer" href="https://www.facebook.com/drivingtestgr" target="_blank" title="facebook"><b-icon scale="2" icon="facebook"></b-icon></a></li>
                            <li class="list-inline-item"><a rel="noreferrer" href="https://www.instagram.com/drivingtestgr" target="_blank" title="instagram"><b-icon scale="2" icon="instagram"></b-icon></a></li>
                        </ul>
                    </b-col>
                    <b-col sm="12" md="3" lg="3" xl="3">
                        <p class="text-uppercase font-weight-bold mb-4">Δίπλωμα οδήγησης</p>
                        <ul class="list-unstyled mb-0">
                            <li class="mb-2"><router-link :to="{ name:'books' }">Επίσημα βιβλία του Κ.Ο.Κ</router-link></li>
                            <li class="mb-2"><router-link :to="{ name:'road_signs' }">Πινακίδες σήμανσης του Κ.Ο.Κ.</router-link></li>
                            <li class="mb-2"><a :href="$store.getters.global.urls.view.test_kok_ypourgeiou_gia_simata_odigisis">Test K.O.K. Υπουργείου</a></li>
                            <li class="mb-2"><a :href="$store.getters.global.urls.view.test_drive">Test Drive</a></li>
                            <li class="mb-2"><a :href="$store.getters.global.urls.view.eidikh_adeia_taxi">Ειδική Άδεια Ταξί</a></li>
                            <li class="mb-2"><a :href="$store.getters.global.urls.view.apwleia_h_kloph_fthora_diplwmatos">Απώλεια ή Κλοπή-Φθορά διπλώματος</a></li>
                            <li class="mb-2"><a :href="$store.getters.global.urls.view.ananewsh_diplwmatos_odhghshs">Ανανέωση διπλώματος οδήγησης</a></li>
                            <li class="mb-2"><a :href="$store.getters.global.urls.view.metabibaseis">Μεταβιβάσεις</a></li>
                            <li class="mb-2"><a :href="$store.getters.global.urls.view.karta_pshfiakoy_taxografoy">Κάρτα ψηφιακού ταχογράφου</a></li>
                            <li class="mb-2"><a :href="$store.getters.global.urls.view.seso_sustima">Σύστημα Ελέγχου Συμπεριφοράς Οδηγών (Σ.Ε.Σ.Ο.)</a></li>
                            <li class="mb-2"><a :href="$store.getters.global.urls.view.odigisi_mixanis_me_diploma_autokinitou">Οδήγηση μηχανής με δίπλωμα αυτοκινήτου</a></li>
                            <li class="mb-2"><a :href="$store.getters.global.urls.view.proswrinh_adeia_odhghshs">Προσωρινή Άδεια Οδήγησης</a></li>
                        </ul>

                    </b-col>
                    <b-col sm="12" md="3" lg="3" xl="3">
                        <p class="text-uppercase font-weight-bold mb-4">Χρήσιμες Πληροφορίες</p>
                        <ul class="list-unstyled mb-0">
                            <li class="mb-2" style="display: none;"><a href="#">Έχεις Σχολή Οδηγών</a></li>
                            <li class="mb-2" style="display: none;"><a href="#">Είσαι μαθητής</a></li>
                            <li class="mb-2"><a :href="$store.getters.global.urls.view.terms_of_use">{{ __('global.link.terms_of_use') }}</a></li>
                            <li class="mb-2"><a :href="$store.getters.global.urls.view.privacy_policy">{{ __('global.link.privacy_policy') }}</a></li>
                            <li class="mb-2"><a href="#" id="cookie_preferences">Cookies</a></li>
                        </ul>
                    </b-col>
                    <b-col sm="12" md="3" lg="3" xl="3" class="newsletter">
                        <p class="text-uppercase font-weight-bold mb-4">Newsletter</p>
                        <p class="mb-4"></p>
                        <div class="p-1 rounded border">
                            <div class="input-group">
                                <input v-model="form_newsletter.email"
                                       @keydown.enter="_.isEmpty(form_newsletter.email) ? doNewsletterSubscribe() : $bvModal.show('modal-recaptcha')"
                                       type="email"
                                       :placeholder="__('global.newsletter.email_placeholder')"
                                       aria-describedby="button-addon1"
                                       class="form-control border-0 shadow-0">
                                <div class="input-group-append">

                                    <button @click="_.isEmpty(form_newsletter.email) ? doNewsletterSubscribe() : $bvModal.show('modal-recaptcha')" class="btn btn-link"><b-icon icon="cursor"></b-icon></button>

                                    <b-modal id="modal-recaptcha" :title="global.name" hide-footer>
                                        <p class="my-2">
                                            <input v-model="form_newsletter.email"
                                                   type="email"
                                                   :placeholder="__('global.newsletter.email_placeholder')"
                                                   aria-describedby="button-addon1"
                                                   class="form-control">

                                            <vue-recaptcha ref="vueRecaptcha" class="m-2"
                                                           @verify="onCaptchaVerified"
                                                           @expired="onCaptchaExpired"
                                                           :sitekey="$store.getters.global.google.recaptcha_site_key"
                                                           :loadRecaptchaScript="true"
                                                           :language="$store.getters['language/selectedId']"></vue-recaptcha>

                                            <button id="button-addon1" :disabled="_.isEmpty(form_newsletter.google_recaptcha_response)"
                                                    @click="doNewsletterSubscribe" class="btn btn-primary">{{ __('global.newsletter.subscribe') }}</button>
                                        </p>
                                    </b-modal>

                                </div>
                            </div>
                        </div>

                        <div class="text-center">
                            <a href='https://play.google.com/store/apps/details?id=gr.techdev.drivingtest&utm_source=drivingtest&utm_campaign=footer&pcampaignid=pcampaignidMKT-Other-global-all-co-prtnr-py-PartBadge-Mar2515-1'>
                                <img style="width: 100%; max-width: 200px;" alt='Αποκτήστε το στο Google Play'
                                     src='https://www.drivingtest.gr/storage/assets/google-play.png'/>
                            </a>
                        </div>

                    </b-col>
                </b-row>

            </b-container>
        </div>

        <!-- Copyrights -->
        <div class="bg-light py-4">
            <div class="container text-center">
                <p class="text-black-100 mb-0 py-2">© {{ moment().format('Y') }} {{ global.name }} All rights reserved.</p>
            </div>
        </div>
    </div>
</template>

<script type="text/babel">
    import { mapGetters } from 'vuex'
    import { mapActions } from 'vuex'
    import VueRecaptcha from 'vue-recaptcha';

    export default {
        name: 'Footer',
        components: { VueRecaptcha },
        data() {
            return {
                form_newsletter: {
                    email : null,
                    google_recaptcha_response: null,
                },
            };
        },
        computed : {
            ...mapGetters({
                global : 'global',
            }),
        },
        methods : {
            ...mapActions({
                'newsletterSubscribe': 'newsletterSubscribe',
            }),
            doNewsletterSubscribe() {

                if(_.isEmpty(this.form_newsletter.email)) {
                    alertify.alert(this.__('global.newsletter.email_placeholder'));
                    return;
                }

                this.newsletterSubscribe(this.form_newsletter).then((response) => {
                    this.form_newsletter.google_recaptcha_response = null;

                    if(response.data.status) {
                        this.$bvModal.hide('modal-recaptcha');

                        this.form_newsletter = {
                            email : null,
                            google_recaptcha_response: null,
                        };
                    } else {
                        this.$refs.vueRecaptcha.reset();
                    }

                    alertify.alert(response.data.message);
                });

            },
            onCaptchaVerified(response) {
                this.form_newsletter.google_recaptcha_response = response;
            },
            onCaptchaExpired() {

            },
        },
    }
</script>
